import React, {createContext, useContext, useState, useEffect} from "react";

const MetronicSplashScreenContext = createContext();

export function MetronicSplashScreenProvider({ children }) {
  const [count, setCount] = useState(0);
  let visible = count > 0;

  useEffect(() => {
    const splashScreen = document.getElementById("splash-screen");
    
    if (!splashScreen) {
      return;
    }

    // Show SplashScreen
    if (visible) {
      splashScreen.classList.remove("hidden");
      // Ensure it's visible and positioned correctly
      splashScreen.style.display = "flex";

      return () => {
        splashScreen.classList.add("hidden");
      };
    }

    // Hide SplashScreen with proper cleanup
    let timeout;
    if (!visible) {
      timeout = setTimeout(() => {
        splashScreen.classList.add("hidden");
        // After transition completes, remove from layout
        setTimeout(() => {
          if (splashScreen.classList.contains("hidden")) {
            splashScreen.style.display = "none";
          }
        }, 350); // Wait for CSS transition to complete (300ms + buffer)
      }, 1000); // Reduced timeout from 3000ms to 1000ms for faster hiding
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [visible]);

  return (
    <MetronicSplashScreenContext.Provider value={setCount}>
      {children}
    </MetronicSplashScreenContext.Provider>
  );
}

export function LayoutSplashScreen({ visible = true }) {
  // Everything are ready - remove splashscreen
  const setCount = useContext(MetronicSplashScreenContext);

  useEffect(() => {
    if (!visible) {
      return;
    }

    setCount(prev => {
      return prev + 1;
    });

    return () => {
      setCount(prev => {
        return prev - 1;
      });
    };
  }, [setCount, visible]);

  return null;
}
